<div [ngSwitch]="salaryComponentName">
  <ng-container *ngSwitchCase="'customEarnings'">
    <div class="modal-header header-border justify-content-between m-2">
      <h5 class="modal-title">Add New Earning</h5>
      <button
        type="button"
        class="btn-close custom-btn-close"
        aria-label="Close"
        (click)="onClose()"
      >
        <i class="ti ti-x"></i>
      </button>
    </div>
    <div class="modal-body m-2">
      <div class="contact-grids-tab">
        <ul class="nav nav-underline" id="myTab" role="tablist">
          <li
            class="nav-item"
            role="presentation"
            [class.active]="currentStep === 1"
            (click)="stepChange(1)"
          >
            <span class="nav-link" [class.active]="currentStep === 1">Basic Information</span>
          </li>
          <li
            class="nav-item"
            role="presentation"
            [class.active]="currentStep === 2"
            (click)="stepChange(2)"
          >
            <span class="nav-link" [class.active]="currentStep === 2">Advanced</span>
          </li>
        </ul>
      </div>
      <div class="tab-content">
        <form [formGroup]="form">
          <!-- Step 1 (Basic Info) -->
          <div *ngIf="currentStep === 1">
            <!-- TODO: Do not show select box if user is an employee -->
            <div class="my-4">
              <label for="belongsTo" class="form-label"
                >Business Entity Name <span class="text-danger">*</span></label
              >
              <select id="select-business" class="form-select" formControlName="belongsTo">
                <option value="" disabled selected>Select Business</option>
                <option *ngFor="let item of businessesList" [value]="item.id">
                  {{ item.businessName | capitalize }}
                </option>
              </select>
              <div *ngIf="form.get('belongsTo')?.errors?.['required']">
                <span class="text-danger">
                  {{ getErrorMessage('belongsTo') }}
                </span>
              </div>
            </div>
            <div id="first-field">
              <div class="row earning-row">
                <div>
                  <label for="name" class="form-label"
                    >Earning Name <span class="text-danger">*</span></label
                  >
                  <input type="text" class="form-control" formControlName="name" appTrimInput />
                  <div *ngIf="form.get('name')?.errors?.['required']">
                    <span class="text-danger">
                      {{ getErrorMessage('name') }}
                    </span>
                  </div>
                </div>
                <div>
                  <label for="description" class="form-label">Description</label>
                  <textarea
                    class="form-control"
                    formControlName="description"
                    appTrimInput
                  ></textarea>
                </div>
              </div>
              <div class="my-4" formGroupName="info">
                <label for="payType" class="form-label">Pay Type</label>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="fixedPay"
                    value="fixedPay"
                    formControlName="payType"
                  />
                  <label class="form-check-label" for="fixedPay">
                    Fixed Pay: (Fixed amount paid at the end of every month)
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="variablePay"
                    value="variablePay"
                    formControlName="payType"
                  />
                  <label class="form-check-label" for="variablePay">
                    Variable Pay: (Variable amount paid during any payroll)
                  </label>
                </div>
              </div>
              <div class="my-4" formGroupName="info">
                <label for="calculationType" class="form-label">Calculation Type</label>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="flatAmount"
                    value="flatAmount"
                    formControlName="calculationType"
                  />
                  <label class="form-check-label" for="flatAmount"> Flat Amount </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="percentageOfBasic"
                    value="percentageOfBasic"
                    formControlName="calculationType"
                  />
                  <label class="form-check-label" for="percentageOfBasic">
                    Percentage of Basic
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="percentageOfCTC"
                    value="percentageOfCTC"
                    formControlName="calculationType"
                  />
                  <label class="form-check-label" for="percentageOfCTC"> Percentage of CTC </label>
                </div>
              </div>
              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="button"
                  (click)="goToNextStep()"
                  [disabled]="!form.get('name')?.valid || !form.get('belongsTo')?.valid"
                  class="btn btn-primary wizard-next-btn"
                >
                  Save & Next
                </button>
              </div>
            </div>
          </div>
          <!-- Step 2 (Advanced) -->
          <div *ngIf="currentStep === 2" formGroupName="info">
            <div class="row">
              <div class="my-4">
                <label for="taxDeductionPreference" class="form-label"
                  >Tax deduction preference</label
                >
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="subsequentPayrolls"
                    value="subsequentPayrolls"
                    formControlName="taxDeductionPreference"
                  />
                  <label class="form-check-label" for="subsequentPayrolls">
                    Deduct tax in subsequent payrolls of the financial year
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="samePayroll"
                    value="samePayroll"
                    formControlName="taxDeductionPreference"
                  />
                  <label class="form-check-label" for="samePayroll">
                    Deduct tax in the same payroll
                  </label>
                </div>
              </div>
              <div class="my-4">
                <div class="form-check form-switch">
                  <label class="form-check-label" for="taxable">Taxable</label>
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="taxable"
                    formControlName="taxable"
                  />
                </div>
              </div>
              <div class="my-4">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="isInCTC"
                    formControlName="isInCTC"
                  />
                  <label class="form-check-label" for="isInCTC">Is in CTC</label>
                </div>
              </div>
              <div class="my-4">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="proRataBasis"
                    formControlName="proRataBasis"
                  />
                  <label class="form-check-label" for="proRataBasis"
                    >Calculation pro-rata basis</label
                  >
                </div>
              </div>
              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="submit"
                  (click)="sendDataToParent()"
                  class="btn btn-primary wizard-next-btn"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'customDeductions'">
    <div class="modal-header header-border justify-content-between m-2">
      <h5 class="modal-title">Add New Deduction</h5>
      <button
        type="button"
        class="btn-close custom-btn-close"
        aria-label="Close"
        (click)="onClose()"
      >
        <i class="ti ti-x"></i>
      </button>
    </div>
    <div class="modal-body m-2">
      <form [formGroup]="form">
        <div id="first-field">
          <div class="row earning-row">
            <div class="my-4">
              <label for="belongsTo" class="form-label"
                >Business Entity Name <span class="text-danger">*</span></label
              >
              <select class="form-select" formControlName="belongsTo">
                <option value="" disabled selected>Select Business</option>
                <option *ngFor="let item of businessesList" [value]="item.id">
                  {{ item.businessName | capitalize }}
                </option>
              </select>

              <div *ngIf="form.get('belongsTo')?.errors?.['required']">
                <span class="text-danger">
                  {{ getErrorMessage('belongsTo') }}
                </span>
              </div>
            </div>
            <div>
              <label for="name" class="form-label"
                >Deduction Name <span class="text-danger">*</span></label
              >
              <input type="text" class="form-control" formControlName="name" appTrimInput />
              <div *ngIf="form.get('name')?.errors?.['required']">
                <span class="text-danger">
                  {{ getErrorMessage('name') }}
                </span>
              </div>
            </div>
            <div>
              <label for="description" class="form-label">Description</label>
              <textarea class="form-control" formControlName="description" appTrimInput></textarea>
            </div>
          </div>
          <div class="my-4" formGroupName="info">
            <label for="deductionPlan" class="form-label"
              >Deduction Plan <span class="text-danger">*</span></label
            >
            <select class="form-select" formControlName="deductionPlan">
              <!-- <option  disabled selected>Select Business</option> -->
              <option value="nps">National Pension Scheme</option>
              <option value="vpf">Voluntary Provident Fund</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div class="my-4" formGroupName="info">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                id="isInctc"
                formControlName="isInCTC"
              />
              <label class="form-check-label" for="isInctc">Employer's contribution in CTC</label>
            </div>
          </div>
          <div class="my-4" formGroupName="info">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                id="proRataBasis"
                formControlName="proRataBasis"
              />
              <label class="form-check-label" for="proRataBasis">Calculation pro-rata basis</label>
            </div>
          </div>
          <div class="my-4" formGroupName="info">
            <label for="taxable" class="form-label">Deduction Type</label>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                id="preTaxDeduction"
                [value]="true"
                formControlName="taxable"
              />
              <label class="form-check-label" for="preTaxDeduction"> Pre-Tax Deduction </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                id="postTaxDeduction"
                [value]="false"
                formControlName="taxable"
              />
              <label class="form-check-label" for="postTaxDeduction"> Post-Tax Deduction </label>
            </div>
          </div>
          <div class="col-lg-12 text-end form-wizard-button">
            <button
              type="button"
              (click)="sendDataToParent()"
              [disabled]="!form.get('name')?.valid || !form.get('belongsTo')?.valid"
              class="btn btn-primary wizard-next-btn"
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'reimbursements'">
    <div class="modal-header header-border justify-content-between m-2">
      <h5 class="modal-title">Add New Earning</h5>
      <button
        type="button"
        class="btn-close custom-btn-close"
        aria-label="Close"
        (click)="onClose()"
      >
        <i class="ti ti-x"></i>
      </button>
    </div>
    <div class="modal-body m-2">
      <div class="contact-grids-tab">
        <ul class="nav nav-underline" id="myTab" role="tablist">
          <li
            class="nav-item"
            role="presentation"
            [class.active]="currentStep === 1"
            (click)="stepChange(1)"
          >
            <span class="nav-link" [class.active]="currentStep === 1">Basic Information</span>
          </li>
          <li
            class="nav-item"
            role="presentation"
            [class.active]="currentStep === 2"
            (click)="stepChange(2)"
          >
            <span class="nav-link" [class.active]="currentStep === 2">Advanced</span>
          </li>
        </ul>
      </div>
      <div class="tab-content">
        <form [formGroup]="form">
          <!-- Step 1 (Basic Info) -->
          <div *ngIf="currentStep === 1">
            <div class="my-4">
              <label for="belongsTo" class="form-label"
                >Business Entity Name <span class="text-danger">*</span></label
              >
              <select class="form-select" formControlName="belongsTo">
                <option value="" disabled selected>Select Business</option>
                <option *ngFor="let item of businessesList" [value]="item.id">
                  {{ item.businessName | capitalize }}
                </option>
              </select>

              <div *ngIf="form.get('belongsTo')?.errors?.['required']">
                <span class="text-danger">
                  {{ getErrorMessage('belongsTo') }}
                </span>
              </div>
            </div>
            <div id="first-field">
              <div class="row earning-row">
                <div>
                  <label for="name" class="form-label"
                    >Earning Name <span class="text-danger">*</span></label
                  >
                  <input type="text" class="form-control" formControlName="name" />
                  <div *ngIf="form.get('name')?.errors?.['required']">
                    <span class="text-danger">
                      {{ getErrorMessage('name') }}
                    </span>
                  </div>
                </div>
                <div>
                  <label for="description" class="form-label">Description</label>
                  <textarea class="form-control" formControlName="description"></textarea>
                </div>
              </div>
              <div class="my-4" formGroupName="info">
                <label for="payType" class="form-label">Pay Type</label>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="fixedPay"
                    value="fixedPay"
                    formControlName="payType"
                  />
                  <label class="form-check-label" for="fixedPay">
                    Fixed Pay: (Fixed amount paid at the end of every month)
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="variablePay"
                    value="variablePay"
                    formControlName="payType"
                  />
                  <label class="form-check-label" for="variablePay">
                    Variable Pay: (Variable amount paid during any payroll)
                  </label>
                </div>
              </div>
              <!-- <div class="my-4">
                <label class="form-label">Calculation Type</label>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="flatAmount"
                    value="flatAmount"
                    formControlName="calculationType"
                  />
                  <label class="form-check-label" for="flatAmount">
                    Flat Amount
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="percentageOfBasic"
                    value="percentageOfBasic"
                    formControlName="calculationType"
                  />
                  <label class="form-check-label" for="percentageOfBasic">
                    Percentage of Basic
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="percentageOfCTC"
                    value="percentageOfCTC"
                    formControlName="calculationType"
                  />
                  <label class="form-check-label" for="percentageOfCTC">
                    Percentage of CTC
                  </label>
                </div>
              </div> -->
              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="button"
                  (click)="goToNextStep()"
                  [disabled]="!form.get('name')?.valid || !form.get('belongsTo')?.valid"
                  class="btn btn-primary wizard-next-btn"
                >
                  Save & Next
                </button>
              </div>
            </div>
          </div>
          <!-- Step 2 (Advanced) -->
          <div *ngIf="currentStep === 2" formGroupName="info">
            <div class="row">
              <div class="my-4">
                <label for="paymentFrequency" class="form-label">Payment Frequency</label>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="monthly"
                    value="monthly"
                    formControlName="paymentFrequency"
                    (change)="onSelectionChange()"
                  />
                  <label class="form-check-label" for="subsequentPayrolls"> Monthly </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="quarterly"
                    value="quarterly"
                    formControlName="paymentFrequency"
                    (change)="onSelectionChange()"
                  />
                  <label class="form-check-label" for="subsequentPayrolls"> Quarterly </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="halfyearly"
                    value="halfyearly"
                    formControlName="paymentFrequency"
                    (change)="onSelectionChange()"
                  />
                  <label class="form-check-label" for="subsequentPayrolls"> Half Yearly </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="annually"
                    value="annually"
                    formControlName="paymentFrequency"
                    (change)="onSelectionChange()"
                  />
                  <label class="form-check-label" for="subsequentPayrolls"> Annually </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="other"
                    value="other"
                    formControlName="paymentFrequency"
                    (change)="onOtherSelected()"
                  />
                  <label class="form-check-label" for="other"> Other </label>
                  <div *ngIf="showCustomInput">
                    <input
                      id="custom"
                      type="number"
                      class="form-control"
                      formControlName="paymentFrequency"
                      [(ngModel)]="customInput"
                    />
                    <label class="form-check-label" for="custom"> In Months </label>
                  </div>
                </div>
              </div>
              <div class="my-4">
                <div class="form-check form-switch">
                  <label class="form-check-label" for="taxable">Taxable</label>
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="taxable"
                    formControlName="taxable"
                  />
                </div>
              </div>
              <div class="my-4">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="isInFBP"
                    formControlName="isInFBP"
                  />
                  <label class="form-check-label" for="isInFBP">Is in FBP</label>
                </div>
              </div>
              <div class="my-4">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="proRataBasis"
                    formControlName="proRataBasis"
                  />
                  <label class="form-check-label" for="proRataBasis"
                    >Calculation pro-rata basis</label
                  >
                </div>
              </div>
              <div class="col-lg-12 text-end form-wizard-button">
                <button
                  type="submit"
                  (click)="sendDataToParent()"
                  class="btn btn-primary wizard-next-btn"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </ng-container>
</div>
